import React from "react";

interface KnowUsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const KnowUsModal: React.FC<KnowUsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-900">Know Us</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 py-8">
          <div className="prose prose-lg max-w-none">
            {/* Main Content */}
            <div className="mb-8">
              <p className="text-gray-700 leading-relaxed mb-6">
                At <strong>Startup Worth</strong>, we empower founders, CFOs, and early-stage teams to make smarter financial decisions, faster.
              </p>

              <p className="text-gray-700 leading-relaxed mb-6">
                Founded by <strong>Rahul Sivarajan</strong>, a CFA charterholder with over 15 years of deep-rooted expertise in startup valuation, financial modeling, and investment readiness, our mission is simple:
              </p>

              <blockquote className="border-l-4 border-purple-500 pl-6 py-4 bg-purple-50 rounded-r-lg mb-6">
                <p className="text-gray-800 font-medium italic text-lg">
                  "To eliminate guesswork from startup valuation and give founders investor-grade clarity, confidence, and conviction."
                </p>
              </blockquote>

              <p className="text-gray-700 leading-relaxed mb-8">
                Rahul has consulted for venture-backed startups, family offices, and global M&A advisory firms — building a track record that spans pre-seed pitch decks to $100M+ scale-up transactions. His command over valuation frameworks (VC, Berkus, Scorecard, DCF, Comparables) and his sharp understanding of equity structuring, ESOP pools, and due diligence have made him a trusted advisor across the founder-investor spectrum.
              </p>
            </div>

            {/* Who We Work With Section */}
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Who We Work With</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-purple-500 mr-3 mt-1">•</span>
                  <span className="text-gray-700">Startup founders preparing to raise capital</span>
                </li>
                <li className="flex items-start">
                  <span className="text-purple-500 mr-3 mt-1">•</span>
                  <span className="text-gray-700">CFOs and financial advisors managing multiple ventures</span>
                </li>
                <li className="flex items-start">
                  <span className="text-purple-500 mr-3 mt-1">•</span>
                  <span className="text-gray-700">Angel networks, incubators, and accelerators</span>
                </li>
                <li className="flex items-start">
                  <span className="text-purple-500 mr-3 mt-1">•</span>
                  <span className="text-gray-700">Early employees negotiating ESOPs</span>
                </li>
                <li className="flex items-start">
                  <span className="text-purple-500 mr-3 mt-1">•</span>
                  <span className="text-gray-700">Legal advisors seeking financial support on deals</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 rounded-b-2xl">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition-colors font-medium"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KnowUsModal;
